import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { PromoTicker } from "@/components/PromoTicker";
import { useSettings } from "@/lib/api";

export const Layout = () => {
  const { pathname } = useLocation();
  const settings = useSettings();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen bg-white text-[#0A0B0E]">
      {settings && !settings.payments_enabled && (
        <div className="bg-[#0A0B0E] px-4 py-1.5 text-center text-[11px] font-medium tracking-wide text-white" data-testid="preview-banner">
          Anteprima del negozio · gli ordini online non sono ancora attivi
        </div>
      )}
      <PromoTicker />
      <Header />
      <main><Outlet /></main>
      <Footer />
      <CartDrawer />
    </div>
  );
};
